import React, { useEffect, useRef, useState } from 'react';
import { errorToast, getJWTToken, getLocalStorageItem, useOutsideClick } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import DashboardInfoCard from '../../component/common/DashboardInfoCard';
import { CompanyApi } from '../../api/companyApi';

function InstantSupportInsights(props) {
  const { companyId } = JSON.parse(localStorage.getItem('userData')); // userType can also be used

  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  // Modified state setters to also save to local storage
  const [companyTotaltSeatsInsights, setCompanyTotalSeatsInsights] = useState(() => {
    const savedTotalSeats = localStorage.getItem('companyTotalSeats');
    return savedTotalSeats ? parseInt(savedTotalSeats, 10) : 0;
  });

  const [companyUsedSeatsInights, setCompanyUsedSeatsInsights] = useState(() => {
    const savedUsedSeats = localStorage.getItem('companyUsedSeats');
    return savedUsedSeats ? parseInt(savedUsedSeats, 10) : 0;
  });

  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  // Custom setter for total seats that also saves to local storage
  const updateCompanyTotalSeats = (value) => {
    setCompanyTotalSeatsInsights(value);
    localStorage.setItem('companyTotalSeats', value.toString());
  };

  // Custom setter for used seats that also saves to local storage
  const updateCompanyUsedSeats = (value) => {
    setCompanyUsedSeatsInsights(value);
    localStorage.setItem('companyUsedSeats', value.toString());
  };

  const subAdminStatusCards = [
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M24.0973 16.8408H14.2051"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.5659 23.5684H24.458"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.8395 14.2061C15.7857 14.7329 14.732 15.7866 14.2051 16.8403C14.732 17.8941 15.7857 18.9478 16.8395 19.4747"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M21.8237 20.9346C22.8774 21.4614 23.9311 22.5152 24.458 23.5689C23.9311 24.6226 22.8774 25.6764 21.8237 26.2032"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M34.4047 21.0855C36.0212 19.677 38.3886 19.9295 39.662 21.6545C39.8526 21.9127 40.0822 22.2147 40.3797 22.587C42.2682 24.9489 42.2682 28.369 40.3693 30.7226C38.9678 32.4601 37.4981 34.2133 35.8552 35.8562C34.2125 37.499 32.4593 38.9685 30.7218 40.3703C28.3682 42.2689 24.9481 42.2689 22.5862 40.3807C22.1677 40.0462 21.8392 39.7985 21.5621 39.5961C19.8903 38.3749 19.6068 36.0875 20.9607 34.521C21.5771 33.808 22.2305 33.1166 22.8748 32.4383C23.7646 31.5014 25.2922 31.3972 26.2671 32.2453C26.4382 32.3941 26.6558 32.5908 26.9566 32.8729C29.6584 31.2674 31.2959 29.61 32.8721 26.9574C32.5849 26.6511 32.386 26.4309 32.2358 26.258C31.3894 25.2836 31.4929 23.7606 32.4358 22.8793C33.081 22.2763 33.7352 21.6688 34.4047 21.0855Z"
            fill="#B6C0F3"
          />
          <path
            d="M34.4047 21.0855C36.0212 19.677 38.3886 19.9295 39.662 21.6545C39.8526 21.9127 40.0822 22.2147 40.3797 22.587C42.2682 24.9489 42.2682 28.369 40.3693 30.7226C38.9678 32.4601 37.4981 34.2133 35.8552 35.8562C34.2125 37.499 32.4593 38.9685 30.7218 40.3703C28.3682 42.2689 24.9481 42.2689 22.5862 40.3807C22.1677 40.0462 21.8392 39.7985 21.5621 39.5961C19.8903 38.3749 19.6068 36.0875 20.9607 34.521C21.5771 33.808 22.2305 33.1166 22.8748 32.4383C23.7646 31.5014 25.2922 31.3972 26.2671 32.2453C26.4382 32.3941 26.6558 32.5908 26.9566 32.8729C29.6584 31.2674 31.2959 29.61 32.8721 26.9574C32.5849 26.6511 32.386 26.4309 32.2358 26.258C31.3894 25.2836 31.4929 23.7606 32.4358 22.8793C33.081 22.2763 33.7352 21.6688 34.4047 21.0855Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Total Seats'}
      value={companyTotaltSeatsInsights === 99999 ? '-' : companyTotaltSeatsInsights}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M28.4745 40.866C36.9995 40.866 41.7949 36.0671 41.7949 27.536C41.7949 19.0048 36.9995 14.2061 28.4745 14.2061C19.9494 14.2061 15.1541 19.0048 15.1541 27.536C15.1541 30.1404 15.601 32.397 16.4645 34.2754L14.2742 40.3034C13.9568 41.1767 14.7874 42.0305 15.6684 41.7368L21.9403 39.6446C23.7768 40.4498 25.9639 40.866 28.4745 40.866Z"
            fill="#B6C0F3"
          />
          <path
            d="M28.4745 40.866C36.9996 40.866 41.7949 36.0671 41.7949 27.536C41.7949 19.0048 36.9996 14.2061 28.4745 14.2061C19.9494 14.2061 15.1541 19.0048 15.1541 27.536C15.1541 30.1404 15.601 32.397 16.4645 34.2754L14.2742 40.3034C13.9568 41.1767 14.7874 42.0305 15.6684 41.7368L21.9403 39.6446C23.7768 40.4498 25.9639 40.866 28.4745 40.866Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.0552 22.3815C22.5208 21.8748 23.1301 21.5551 23.7837 21.4746C25.8195 21.2364 27.82 21.2362 29.8559 21.4746C30.5094 21.5551 31.1187 21.8748 31.5844 22.3815C32.05 22.8882 32.3446 23.5521 32.42 24.2649C32.4313 24.375 32.4421 24.4849 32.4523 24.5946C33.0438 24.2524 33.677 23.9349 34.3355 23.6702C35.2022 23.3217 36.1564 23.738 36.4216 24.6336C36.654 25.4171 36.8476 26.4356 36.8476 27.5963C36.8476 28.7569 36.654 29.7755 36.4216 30.559C36.1564 31.4546 35.2022 31.8708 34.3355 31.5224C33.6772 31.2577 33.0441 30.9403 32.4527 30.5982C32.4427 30.7079 32.4321 30.8179 32.4209 30.9281C32.3455 31.6409 32.051 32.3047 31.5853 32.8115C31.1196 33.3182 30.5103 33.6379 29.8568 33.7184C27.8206 33.9564 25.8198 33.9566 23.7837 33.7184C23.1301 33.6379 22.5208 33.3182 22.0552 32.8115C21.5895 32.3047 21.2949 31.6409 21.2195 30.9281C20.9882 28.68 20.9884 26.513 21.2195 24.2649C21.2949 23.5521 21.5895 22.8882 22.0552 22.3815Z"
            fill="white"
          />
          <path
            d="M22.0552 22.3815C22.5208 21.8748 23.1301 21.5551 23.7837 21.4746C25.8195 21.2364 27.82 21.2362 29.8559 21.4746C30.5094 21.5551 31.1187 21.8748 31.5844 22.3815C32.05 22.8882 32.3446 23.5521 32.42 24.2649C32.4313 24.375 32.4421 24.4849 32.4523 24.5946C33.0438 24.2524 33.677 23.9349 34.3355 23.6702C35.2022 23.3217 36.1564 23.738 36.4216 24.6336C36.654 25.4171 36.8476 26.4356 36.8476 27.5963C36.8476 28.7569 36.654 29.7755 36.4216 30.559C36.1564 31.4546 35.2022 31.8708 34.3355 31.5224C33.6772 31.2577 33.0441 30.9403 32.4527 30.5982C32.4427 30.7079 32.4321 30.8179 32.4209 30.9281C32.3455 31.6409 32.0509 32.3047 31.5853 32.8115C31.1196 33.3182 30.5103 33.6379 29.8568 33.7184C27.8206 33.9564 25.8198 33.9566 23.7837 33.7184C23.1301 33.6379 22.5208 33.3182 22.0552 32.8115C21.5895 32.3047 21.2949 31.6409 21.2195 30.9281C20.9882 28.68 20.9884 26.513 21.2195 24.2649C21.2949 23.5521 21.5895 22.8882 22.0552 22.3815Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Used Seats'}
      value={companyUsedSeatsInights}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.7947 27.7105C41.4347 26.2598 40.6147 24.9615 39.4534 24.0122C38.215 23.0001 36.6649 22.4473 35.0657 22.4473C33.4665 22.4473 31.9164 23.0001 30.6782 24.0122C30.4085 24.2326 30.1573 24.4718 29.9259 24.7274C31.3566 24.987 32.7466 25.6032 33.8794 26.736C34.3069 27.1635 34.6608 27.6275 34.9497 28.1165C37.223 28.1213 39.4958 27.9859 41.7947 27.7105Z"
            fill="#B6C0F3"
          />
          <path
            d="M32.5921 38.0972C33.7534 39.0465 34.5736 40.3449 34.9335 41.7955C34.9335 41.7955 30.8648 42.3259 28.2045 42.3259C25.5443 42.3259 21.4756 41.7955 21.4756 41.7955C21.8356 40.3449 22.6556 39.0465 23.817 38.0972C25.0552 37.0853 26.6053 36.5322 28.2045 36.5322C29.8038 36.5322 31.3538 37.0853 32.5921 38.0972Z"
            fill="#B6C0F3"
          />
          <path
            d="M28.2038 36.5327C30.8411 36.5327 32.3246 35.0492 32.3246 32.4119C32.3246 29.7745 30.8411 28.291 28.2038 28.291C25.5664 28.291 24.0829 29.7745 24.0829 32.4119C24.0829 35.0492 25.5664 36.5327 28.2038 36.5327Z"
            fill="#B6C0F3"
          />
          <path
            d="M34.9335 41.7955C34.5736 40.3449 33.7534 39.0465 32.5921 38.0972C31.3538 37.0851 29.8038 36.5322 28.2045 36.5322C26.6053 36.5322 25.0552 37.0851 23.817 38.0972C22.6556 39.0465 21.8356 40.3449 21.4756 41.7955"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.2038 36.5327C30.8411 36.5327 32.3246 35.0492 32.3246 32.4119C32.3246 29.7745 30.8411 28.291 28.2038 28.291C25.5664 28.291 24.0829 29.7745 24.0829 32.4119C24.0829 35.0492 25.5664 36.5327 28.2038 36.5327Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.0655 22.4478C37.7029 22.4478 39.1864 20.9643 39.1864 18.3269C39.1864 15.6896 37.7029 14.2061 35.0655 14.2061C32.4281 14.2061 30.9446 15.6896 30.9446 18.3269C30.9446 20.9643 32.4281 22.4478 35.0655 22.4478Z"
            fill="#B6C0F3"
          />
          <path
            d="M35.0655 22.4478C37.7029 22.4478 39.1864 20.9643 39.1864 18.3269C39.1864 15.6896 37.7029 14.2061 35.0655 14.2061C32.4281 14.2061 30.9446 15.6896 30.9446 18.3269C30.9446 20.9643 32.4281 22.4478 35.0655 22.4478Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M41.7947 27.7105C41.4347 26.2598 40.6147 24.9615 39.4533 24.0122C38.2152 23.0001 36.6651 22.4473 35.0657 22.4473C33.4666 22.4473 31.9165 23.0001 30.6782 24.0122"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.2054 27.7105C14.5653 26.2598 15.3854 24.9615 16.5467 24.0122C17.785 23.0001 19.3351 22.4473 20.9343 22.4473C22.5335 22.4473 24.0836 23.0001 25.3218 24.0122C25.5915 24.2326 25.8427 24.4718 26.0741 24.7274C24.6434 24.987 23.2534 25.6032 22.1206 26.736C21.6931 27.1635 21.3393 27.6275 21.0503 28.1165C18.7771 28.1213 16.5042 27.9859 14.2054 27.7105Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9346 22.4478C18.2972 22.4478 16.8137 20.9643 16.8137 18.3269C16.8137 15.6896 18.2972 14.2061 20.9346 14.2061C23.5719 14.2061 25.0554 15.6896 25.0554 18.3269C25.0554 20.9643 23.5719 22.4478 20.9346 22.4478Z"
            fill="#B6C0F3"
          />
          <path
            d="M20.9346 22.4478C18.2972 22.4478 16.8137 20.9643 16.8137 18.3269C16.8137 15.6896 18.2972 14.2061 20.9346 14.2061C23.5719 14.2061 25.0554 15.6896 25.0554 18.3269C25.0554 20.9643 23.5719 22.4478 20.9346 22.4478Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.2053 27.7105C14.5653 26.2598 15.3853 24.9615 16.5467 24.0122C17.7849 23.0001 19.335 22.4473 20.9342 22.4473C22.5334 22.4473 24.0835 23.0001 25.3218 24.0122"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Available Seats'}
      value={
        companyTotaltSeatsInsights === 99999
          ? '-'
          : Math.max(0, companyTotaltSeatsInsights - companyUsedSeatsInights)
      }
    />
  ];

  // Use the needsRefresh prop to trigger data fetching
  useEffect(() => {
    if (props.needsRefresh) {
      setLoader(true);

      CompanyApi.getInstantSupportInights(companyId)
        .then((response) => {
          if (response?.status === 200) {
            console.log('Refreshed Insights Data:', response?.data?.data);
            updateCompanyTotalSeats(response?.data?.data?.totalSeats);
            updateCompanyUsedSeats(response?.data?.data?.activeUsersCount);
          }
        })
        .catch((error) => {
          console.error('Error fetching insights data:', error);
        })
        .finally(() => {
          setLoader(false);
          props.refreshCompleted(); // Notify parent that refresh is done
        });
    }
  }, [props.needsRefresh]); // Add needsRefresh as a dependency

  // Keep the initial data loading separate
  useEffect(() => {
    CompanyApi.getInstantSupportInights(companyId).then((response) => {
      if (response?.status === 200) {
        updateCompanyTotalSeats(response?.data?.data?.totalSeats);
        updateCompanyUsedSeats(response?.data?.data?.activeUsersCount);
      }
    });
  }, []); // This runs only on component mount

  return (
    <>
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 mt-5">
        {subAdminStatusCards.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </div>
    </>
  );
}

export default InstantSupportInsights;
